import React from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../../components/MobileMenu'
import LanguageSwitcher from './LanguageSwitcher';
import { useTranslation } from 'react-i18next';


const Header = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    const { t } = useTranslation();

    return (
        <header id="header">
            <div className={`wpo-site-header ${props.hclass}`}>
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                <div className="mobail-menu">
                                    <MobileMenu />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-6">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/home"><img src={props.Logo}
                                        alt="" /></Link>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-1 col-1">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/home">{t('menu.home')}</Link>
                                        </li>
                                        <li><Link onClick={ClickHandler} to="/about">{t('menu.about')}</Link></li>
                                        <li className="menu-item-has-children">
                                            <Link to="/service">{t('menu.service')}</Link>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/project">{t('menu.project')}</Link>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/blog">{t('menu.blog')}</Link>
                                        </li>
                                        <li><Link onClick={ClickHandler} to="/contact">{t('menu.contact')}</Link></li>
                                        <li>
                                        <a href="https://Portal.alriyada.om" target="_blank" rel="noopener noreferrer">
                                            {t('login')}
                                        </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-2 col-2">
                                <div className="header-right">
                                    <div className="header-search-form-wrapper text-black">
                                        <LanguageSwitcher />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}


export default (Header);